import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from "@material-ui/core";
import React from "react";

const formatDate = dateString => {
  if (!dateString) return "";
  const date = new Date(dateString);
  if (isNaN(date)) return "";
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};

const formatSegmentos = segmentos => {
  let segmentosNames = "";

  // Validar que segmentos sea un array y tenga elementos
  if (!Array.isArray(segmentos) || segmentos.length === 0)
    return segmentosNames;

  for (let i = 0; i < segmentos.length; i++) {
    // Agregar una coma solo si no es el primer elemento
    if (i > 0) {
      segmentosNames += ", ";
    }
    segmentosNames += segmentos[i].nombre;
  }

  return segmentosNames;
};

export const ErrorDetailDialog = ({ openDialog, errors = {}, onClose }) => {
  console.log("errors | dialogo--->", errors);

  const { message = "", noticiasConflicto = [] } = errors || {};

  console.log("noticiasConflicto--->", noticiasConflicto.length);

  return (
    <Dialog
      fullScreen={false}
      open={openDialog}
      onClose={onClose}
      aria-labelledby="error-dialog-detail"
      fullWidth
      maxWidth={"md"}
    >
      <DialogTitle id="alert-dialog-description">{message}</DialogTitle>
      <DialogContent>
        {noticiasConflicto.length > 0 ? (
          <>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Id Noticia</TableCell>
                  <TableCell>Título</TableCell>
                  <TableCell align="right">Segmento/s</TableCell>
                  <TableCell align="right">Fecha Inicio</TableCell>
                  <TableCell align="right">Fecha Fin</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {noticiasConflicto.map(noticia => (
                  <TableRow>
                    <TableCell>{noticia.idNoticia}</TableCell>
                    <TableCell component="th" scope="row">
                      {noticia.nombre}
                    </TableCell>
                    <TableCell align="right">
                      {formatSegmentos(noticia.segmentos)}
                    </TableCell>
                    <TableCell align="right">
                      {formatDate(noticia.fechaInicio)}
                    </TableCell>
                    <TableCell align="right">
                      {formatDate(noticia.fechaFin)}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </>
        ) : (
          <DialogContentText> {message}</DialogContentText>
        )}
      </DialogContent>
      <DialogActions>
        <Button
          onClick={onClose}
          color="primary"
          autoFocus
          variant="outlined"
          style={{ margin: "0 2% 2% 0" }}
        >
          Aceptar
        </Button>
      </DialogActions>
    </Dialog>
  );
};
